import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, CircularProgress } from '@material-ui/core';
import { IAppState } from '../redux/modules';
interface OwnProps {
  isLoading: boolean;
}

const Loading: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <Modal
      open={props.isLoading}
    >
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: `translate(-50%, -50%)`
        }}
      >
        <CircularProgress color="primary" />
      </div>
    </Modal>
  );
}

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.loading.isLoading
});

export default connect(
  mapStateToProps,
  null
)(Loading);



// WEBPACK FOOTER //
// ./src/components/Loading.tsx